import { Margin } from '@nivo/core';

// Compensation yMax tend to be 100,000+ which takes up a lot of horizontal space
export const RESPONSIVE_LINE_Y_AXIS_LABEL_OFFSET = -95;
export const RESPONSIVE_LINE_MARGIN: Margin = {
  top: 20,
  bottom: 80,
  left: 120,
  right: 20,
};
